import { createContext, useContext } from 'react'

/**
 * What a `CardRow.Item` tells the cards inside it (ADR-024 part 4, PRD FR-5).
 *
 * Lives apart from `CardRow.tsx` so `ScrollArea` can read a follower's `minItems` floor without
 * importing the row component: `ScrollArea` is an atomic-tier primitive, `CardRow` is layout.
 * `CardRow.Item` (T02) is the only provider.
 */
export interface CardRowItemContextValue {
  role: 'lead' | 'follow'
  /** A follower's floor. A `ScrollArea` inside the item uses it as its default `minItems`. */
  minItems?: number
}

export const CardRowItemContext = createContext<CardRowItemContextValue | null>(null)

/** The enclosing `CardRow.Item`, or `null` outside a `CardRow`. */
export function useCardRowItem(): CardRowItemContextValue | null {
  return useContext(CardRowItemContext)
}
